// frontend entry point
import './scripts/init/localization';
import './scripts/react-habitat/init';
import { applyStyleConfig } from './scripts/util/apply-style-config';
import './styles/frontend.scss';

// Apply style config from options if available
if ( typeof window !== 'undefined' ) {
	// Wait for DOM to be ready and options to be available
	const applyConfig = () => {
		const options = ( window as any ).dhsv100AiChatPluginOptions;
		if ( options && options.styleConfig ) {
			applyStyleConfig( options.styleConfig, {
				autoContrast: options.autoContrast !== false,
			} );
		}
	};

	// Try immediately (options should be available via inline script)
	applyConfig();

	// Also try on DOMContentLoaded as fallback
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', applyConfig );
	}
}
